<template>
    <div class="container" :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
        <p class="text reveal-bottom">{{ text }}</p>
    </div>
</template>
<script>
export default {
    props: {
        text: String,
        imgUrl: String,
    },
};
</script>
<style scoped>
.container {
    height: 300px;
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat: no-repeat;
    background-color: #00a3d1;
}
.text {
    width: 1200px;
    height: 44px;
    font-size: 44px;
    color: #ffffff;
    letter-spacing: 0;
    position: absolute;
    font-weight: bold;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/SubHeader.vue